import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=97b6c2f6&scoped=true&"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./RouteBreadcrumb.vue?vue&type=style&index=0&id=97b6c2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b6c2f6",
  null
  
)

export default component.exports